<div
  *ngIf="supportTermsForm"
  [formGroup]="supportTermsForm"
>
  <mable-heading
    heading="h2"
    headingStyle="h3"
    >Support terms</mable-heading
  >
  <div
    class="mable-note card ion-margin ion-justify-content-start ion-align-items-start"
    *ngIf="isPreFilled"
  >
    <ion-icon
      slot="start"
      name="alert-circle"
      aria-hidden="true"
    ></ion-icon>
    <span>
      To save you time, we've pre-filled the following standard agreement details from the last agreement that you
      created.
    </span>
  </div>
  <ng-container *ngFor="let supportTerm of supportTermsDisplayData">
    <!-- TERM INPUT -->
    <mable-input [label]="supportTerm.label">
      <p class="description">{{ supportTerm.description }}</p>
      <ion-textarea
        autocapitalize="sentences"
        rows="5"
        [formControlName]="supportTerm.control"
        autocomplete="on"
        autocorrect="on"
        spellcheck="true"
        [attr.aria-label]="supportTerm.label"
        (ionChange)="onSupportTermsChange()"
      ></ion-textarea>
    </mable-input>

    <!-- EXAMPLES -->
    <app-collapsible
      [isPanelExpanded]="false"
      [title]="'Examples'"
    >
      <ng-container class="content">
        <div>
          <ng-container *ngFor="let example of supportTerm.examples; let index = index">
            <span>Example {{ index + 1 }}</span>
            <p
              class="text-italic"
              [innerHTML]="example"
            ></p>
          </ng-container>

          <!-- BANNERS -->
          <ng-container [ngSwitch]="supportTerm.control">
            <div
              *ngSwitchCase="'supportCancel'"
              class="mable-note card ion-margin ion-justify-content-start ion-align-items-start price-guide"
            >
              <div>
                You can submit support hours for a missed session if the cancellation notice period isn't met, or you
                can choose not to - depending on the circumstances. For NDIS-funded sessions, refer to the NDIS Short
                Notice Cancellation Guidelines in the NDIS Price Guide.
                <mable-button
                  category="link"
                  class="ion-no-margin ion-no-padding"
                  (onClick)="priceGuide()"
                >
                  View NDIS Price Guide
                </mable-button>
              </div>
            </div>
            <div
              *ngSwitchCase="'supportChange'"
              class="mable-note card ion-margin ion-justify-content-start ion-align-items-start"
            >
              If you can be flexible with your time and you've provided details of different rates in your service
              agreement, you won't need to update your agreement for occasional changes.
            </div>
          </ng-container>
        </div>
      </ng-container>
    </app-collapsible>
  </ng-container>
</div>
